import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'rs-emd-ui-atoms';
import { TextWidget } from '../..';
import { getAttributes } from '../../../../helpers/html.utils';
import { IPopularCategoriesWidget } from '../../../../models/campaign-pages/widgets/popular-categories/popular-categories.model';
import styles from './popular-categories-component.module.scss';

export type PopularCategoriesProps = { popularCategories: IPopularCategoriesWidget };

export const PopularCategories: FunctionComponent<PopularCategoriesProps> = (props: PopularCategoriesProps) => {
  return (
    <Card className={styles['popular-categories-container']} radius={'8px'}>
      <TextWidget
        isContainerFullHeight={false}
        textWidget={{
          textData: [{ ...props.popularCategories.title, textSize: props.popularCategories.title.textSize ?? 'lg' }],
        }}></TextWidget>
      <div className={styles.categories}>
        {props.popularCategories.categories.map((category, i) => {
          return (
            <Link
              id={`pop-cat-${category.id}`}
              to={category.url.url}
              {...getAttributes(category.url.attributes)}
              className={styles.category}>
              {category.imageUrl && (
                <div className={styles.image}>
                  <img className={styles.img} src={category.imageUrl} />
                </div>
              )}
              <div className={styles['category-info']}>
                <span className={styles.label}>
                  {category.url.text} <span className={styles.count}>({category.noOfProducts})</span>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </Card>
  );
};

export default PopularCategories;
